module.exports = __webpack_public_path__ + "img/cvs-trigger-dp.a867ee87.svg";